// extracted by mini-css-extract-plugin
module.exports = {"editTextModal":"src-AdminPanel-pages-Modals-Article-EditArticleTextModal-styles-style-module__editTextModal--2Jjm4"};